import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Bucket from "@/services/bucket/bucket";
import { EditBucket, RegisterBucket } from "@/dtos/Bucket.dto";

export function useRegisterBucket() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (bucket: RegisterBucket) => {
      const result = await Bucket.registerBucket(bucket);
      if (result.data.status) {
        return result.data.data;
      }
      throw new Error(result.data.msg || "Failed to register bucket");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["buckets"] });
      queryClient.invalidateQueries({ queryKey: ["bucketStats"] });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"] });
      queryClient.invalidateQueries({ queryKey: ["dashboardStats"] });
      queryClient.invalidateQueries({ queryKey: ["contact"] });
      queryClient.invalidateQueries({ queryKey: ["bucketLockStatus"] });
    },
  });
}

export function useUpdateBucket() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (bucket: EditBucket) => {
      const result = await Bucket.editBucket(bucket);
      if (result.data.status) {
        return result.data.data;
      }
      throw new Error(result.data.msg || "Failed to update bucket");
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["buckets"] });
      queryClient.invalidateQueries({ queryKey: ["bucketStats"] });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"] });
      queryClient.invalidateQueries({ queryKey: ["dashboardStats"] });
      queryClient.invalidateQueries({ queryKey: ["contact"] });
      queryClient.invalidateQueries({ queryKey: ["bucketLockStatus"] });
    },
  });
}

export function useDeleteBucket() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const result = await Bucket.deleteBucket(id);
      if (result.data.status) {
        return result.data.data;
      }
      throw new Error(result.data.msg || "Failed to delete bucket");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["buckets"] });
      queryClient.invalidateQueries({ queryKey: ["bucketStats"] });
      queryClient.invalidateQueries({ queryKey: ["bucketCounts"] });
      queryClient.invalidateQueries({ queryKey: ["dashboardStats"] });
      queryClient.invalidateQueries({ queryKey: ["contact"] });
      queryClient.invalidateQueries({ queryKey: ["bucketLockStatus"] });
    },
  });
}
